import { toast } from "./toast.js";

const observerCallback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList.contains("js-show-toast")
        ) {
          const toastContainer = node;
          const toastMessage = toastContainer.dataset.message;
          const toastType = toastContainer.dataset.type;
          const toastInnerHtml = toastContainer.innerHTML;
          
          if ((toastMessage || toastInnerHtml) && toastType) {
            toast[toastType](toastMessage, toastInnerHtml);
          }
          toastContainer.remove();
        }
      });
    }
  }
};

function activateShowToastSystem() {
  const toastContainer = document.querySelector(".js-show-toast");

  if (toastContainer) {
    const toastMessage = toastContainer.dataset.message;
    const toastType = toastContainer.dataset.type;
    const toastInnerHtml = toastContainer.innerHTML;
    
    if ((toastMessage || toastInnerHtml) && toastType) {
      toast[toastType](toastMessage, toastInnerHtml);
    }

    toastContainer.remove();
  }

  const observer = new MutationObserver(observerCallback);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initShowToastSystem() {
  if (document.readyState !== "loading") {
    activateShowToastSystem();
  } else {
    document.addEventListener("DOMContentLoaded", activateShowToastSystem);
  }
}

export default initShowToastSystem;